import React from 'react';
import IncorporationOfTerms from 'components/IncorporationOfTerms/IncorporationOfTerms';
import i18n from 'i18n';
import useTitle from 'utils/hook/useTitle';

export const IncorporationOfTermsPage = () => {
  useTitle(i18n.t('BTY_W_T_WELCOME'));

  return <IncorporationOfTerms />;
};

export default IncorporationOfTermsPage;
